import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ArrowSwapButton, Box, Stack } from '@esgian/esgianui';
import { LocationSelect } from '@components/Inputs';
import { useLookupActiveLocations } from '@hooks/useDynamicLookupQueries/useLookupActiveLocations';
import { useLookupCountries } from '@hooks/useStaticLookupQueries/useLookupCountryQuery';
import { GEOGRAPHICAL_TYPES } from '@constants';
function locationSort(a, b) {
  return a?.name?.localeCompare(b?.name);
}
const importOrder = ['Region', 'Country', 'Port'];

const sortByLocation = importOrder.reduce((obj, item, index) => {
  return {
    ...obj,
    [item]: index
  };
}, {});
function LocationLoadAndDischargeSelect({
  handleSwap,
  setSelectedLocationOfLoad,
  setSelectedLocationOfDischarge,
  selectedLocationOfDischarge,
  selectedLocationOfLoad
}) {
  const { data: lookupActiveLocations } = useLookupActiveLocations();
  const { data: lookupCountry } = useLookupCountries();

  const lookupLocations = useMemo(() => {
    if (!lookupActiveLocations.length || !lookupCountry) return [];
    return lookupActiveLocations
      .map((item) => {
        const val = {
          name: item.displayName,
          id: item.geoId,
          isoAlpha2: null,
          locode: null
        };
        if (item.geoType === GEOGRAPHICAL_TYPES.PORT) {
          const match = item.displayName.match(/^(.*?)\s*\((.*?)\)$/);
          val['type'] = 'Port';
          val['name'] = match[1];
          val['locode'] = match[2];
        }
        if (item.geoType === GEOGRAPHICAL_TYPES.REGION) {
          val['type'] = 'Region';
        }
        if (item.geoType === GEOGRAPHICAL_TYPES.COUNTRY) {
          val['type'] = 'Country';
          val['isoAlpha2'] = lookupCountry[item.geoId].isoAlpha2;
        }
        return val;
      })
      .sort(locationSort)
      ?.sort((a, b) => sortByLocation[a.type] - sortByLocation[b.type]);
  }, [lookupActiveLocations, lookupCountry]);

  const handlePortSwap = () => {
    let tempLoad = selectedLocationOfLoad ? { ...selectedLocationOfLoad } : null;
    let tempDist = selectedLocationOfDischarge ? { ...selectedLocationOfDischarge } : null;
    if (handleSwap) {
      handleSwap(tempDist, tempLoad);
    } else {
      setSelectedLocationOfLoad(tempDist);
      setSelectedLocationOfDischarge(tempLoad);
    }
  };
  return (
    <Stack direction={'row'}>
      <Stack className={'section-filter'}>
        <LocationSelect
          label={'Location of Load*'}
          keyPreFix={'load'}
          placeholder={'Search by port, city or region'}
          handleChange={setSelectedLocationOfLoad}
          selectedLocation={selectedLocationOfLoad}
          locationList={lookupLocations}
        />
      </Stack>
      <Box alignSelf={'flex-end'} sx={{ pb: 1 }}>
        <ArrowSwapButton handleClick={handlePortSwap} />
      </Box>
      <Stack className={'section-filter'}>
        <LocationSelect
          label={'Location of Discharge*'}
          keyPreFix={'dist'}
          placeholder={'Search by port, city or region'}
          selectedLocation={selectedLocationOfDischarge}
          handleChange={setSelectedLocationOfDischarge}
          locationList={lookupLocations}
        />
      </Stack>
    </Stack>
  );
}

LocationLoadAndDischargeSelect.propTypes = {
  selectedLocationOfDischarge: PropTypes.object,
  selectedLocationOfLoad: PropTypes.object,
  setSelectedLocationOfLoad: PropTypes.func.isRequired,
  setSelectedLocationOfDischarge: PropTypes.func.isRequired,
  handleSwap: PropTypes.func
};

LocationLoadAndDischargeSelect.defaultProps = {
  selectedLocationOfDischarge: null,
  selectedLocationOfLoad: null,
  handleSwap: null
};

export default LocationLoadAndDischargeSelect;
